module.exports = __webpack_public_path__ + "static/race-6541849623b7a06b4bd2f1457b228f46.jpg";